import * as React from 'react';

import { ActivityNavbar } from '../../../Shared';

const HELP_LINK = 'https://support.quill.org/using-quill-tools/quill-lessons/how-do-i-customize-a-quill-lesson'

const CustomizeNavbar = () => (
  <ActivityNavbar
    helpLink={HELP_LINK}
    title="Create Custom Edition"
    toolName="lessons"
  />
)

export default CustomizeNavbar
